import React, { Component } from "react";
import { Icon } from "antd-mobile";
import styled from "styled-components";
import PropTypes from "prop-types";
import {
  CarouselProvider,
  Slider,
  Slide,
  DotGroup,
  Dot
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import Theme from "../utils/Theme";
import LoadingIndicator from "../components/LoadingIndicator";

const StyledContainer = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  overflow-y: hidden;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
`;

const StyledContent = styled.div`
  max-width: 500px;
  height: 90vh;
  width: 90vw;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
  border-radius: 1em;
`;

const StyledImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 1em;
`;

class BannerModal extends Component {
  onCloseClicked = () => {
    const { onCloseClicked } = this.props;

    onCloseClicked();
  };


  getBannerSlider = bannerData => {
    return bannerData.map(data => {
      return (
        <Slide index={data.id} key={data.id}>
          <StyledContent>
            <StyledImage src={data.large.src} />
          </StyledContent>
        </Slide>
      );
    });
  };

  render() {
    const { bannerData, showBanner, loading } = this.props;

    const row =
      bannerData && bannerData ? bannerData.length : [];

    return showBanner ? (
      <StyledContainer>
        {loading ? <LoadingIndicator /> : null}
        <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={500}
          totalSlides={row}
        >
          <div style={{
            textAlign: 'right',
            maxWidth: '500px',
            margin: 'auto'
          }}>
            <Icon
              onClick={() => this.onCloseClicked()}
              style={{
                backgroundColor:'#fff',
                borderRadius:'100%',
                margin:'10px 10px -10px 0px',
                padding:'5px',
                cursor:'pointer',
              }}
              type={"cross"}
            />
          </div>
          {/*<DotGroup />*/}
          <Slider>
            {this.getBannerSlider(
              bannerData && bannerData ? bannerData : null
            )}
          </Slider>
        </CarouselProvider>
      </StyledContainer>
    ) : null;
  }
}

BannerModal.propTypes = {
  history: PropTypes.object.isRequired,
  bannerData: PropTypes.array,
  showBanner: PropTypes.bool,
  loading: PropTypes.bool,
  onCloseClicked: PropTypes.func
};

BannerModal.defaultProps = {
  showBanner: false
};

export default BannerModal;



// WEBPACK FOOTER //
// ./src/components/BannerModal.js